import { Link } from "react-router-dom";

import { Badge } from "@/components/ui/badge/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/shared/lib/utils";

export interface OverviewSectionProps {
  title: string;
  description?: string;
  /** Badge “Datos de ejemplo” para mocks */
  isMock?: boolean;
  /** CTA opcional (ej. ver detalle) */
  action?: { label: string; to: string };
  className?: string;
  children: React.ReactNode;
}

/**
 * Marco de sección del hub overview (título + badge mock + CTA).
 */
export function OverviewSection({
  title,
  description,
  isMock,
  action,
  className,
  children,
}: OverviewSectionProps): React.JSX.Element {
  return (
    <Card className={cn(className)}>
      <CardHeader className="flex flex-row flex-wrap items-start justify-between gap-3 space-y-0 pb-3">
        <div className="min-w-0 space-y-1">
          <div className="flex flex-wrap items-center gap-2">
            <CardTitle className="text-lg">{title}</CardTitle>
            {isMock && (
              <Badge variant="secondary" className="text-[10px] font-normal">
                Datos de ejemplo
              </Badge>
            )}
          </div>
          {description && <CardDescription>{description}</CardDescription>}
        </div>
        {action && (
          <Button variant="outline" size="sm" asChild>
            <Link to={action.to}>{action.label}</Link>
          </Button>
        )}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
